import styled from 'styled-components';
import { COLOR, BREAKPOINT } from '@latitude/core/utils/constants';
export const Outer = /*#__PURE__*/styled.footer.withConfig({
  displayName: "Footerstyles__Outer",
  componentId: "sc-1riz79s-0"
})(["background-color:", ";"], COLOR.BLUE_BABY);
export const Inner = /*#__PURE__*/styled.div.withConfig({
  displayName: "Footerstyles__Inner",
  componentId: "sc-1riz79s-1"
})(["padding:40px 35px;margin:0 auto;@media (min-width:", "){max-width:960px;padding:40px 20px;}@media (min-width:", "){max-width:1140px;}"], BREAKPOINT.LG, BREAKPOINT.XL);